import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
// Import Bootstrap JS
import * as bootstrap from 'bootstrap'

// Initialize model-viewer webcomponent
import { loadModelViewer } from './utils/modelViewerShim'

// Import global components
import NotificationBadge from './components/NotificationBadge.vue'
import ModelViewerWrapper from './components/ModelViewerWrapper.vue'

// Import API and API fixes
import api from './services/api'
// Re-enable both fix files
import fixExamIdApi from './fix-exam-id'
import fixDiagnosticCasesApi from './fix-diagnostic-cases'

// Apply API fixes in sequence
const fixedApi = fixDiagnosticCasesApi(fixExamIdApi(api))

// Make Bootstrap globally available
window.bootstrap = bootstrap

// Configure axios for CORS
axios.defaults.withCredentials = true

// Removed excessive logging that was causing performance issues

const app = createApp(App)

// Register global components
app.component('NotificationBadge', NotificationBadge)
app.component('ModelViewerWrapper', ModelViewerWrapper)

// Load model-viewer web component
loadModelViewer().catch(error => console.warn('Model-viewer initialization error:', error))

app.use(store)
app.use(router)

// Make the fixed API available globally
app.config.globalProperties.$api = fixedApi
app.provide('api', fixedApi)  // For composition API

// Also make it available in the window for debugging
window.app = { $api: fixedApi }
// Make API available for content protection system
window.api = fixedApi

// Global authentication helper
app.config.globalProperties.$auth = {
  isAuthenticated() {
    return !!localStorage.getItem('authToken');
  },
  requireAuth(redirectTo = '/login') {
    if (!this.isAuthenticated()) {
      router.push(redirectTo);
      return false;
    }
    return true;
  }
}

// Make axios available globally in development
if (process.env.NODE_ENV === 'development') {
  window.axios = axios;
}

app.mount('#app')